export default {
    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {
        deleteFile: ({commit, state}, url) => {
            return new Promise((resolve, reject) => {
                axios.delete(url)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
